var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m17.9813 19.3072c-3.3128 2.6533-8.16212 2.4445-11.2331-.6265-3.29505-3.2951-3.29505-8.6374 0-11.93244 3.2951-3.29504 8.6374-3.29504 11.9324 0 3.071 3.07098 3.2798 7.92024.6265 11.23314l6.4446 6.4445c.3661.3661.3661.9597 0 1.3258s-.9597.3661-1.3258 0zm-9.90727-1.9523c-2.56282-2.5629-2.56282-6.718 0-9.28081 2.56277-2.56282 6.71797-2.56282 9.28077 0 2.5609 2.56091 2.5628 6.71181.0056 9.27511-.0018.0019-.0037.0038-.0056.0056-.0019.0019-.0038.0038-.0056.0057-2.5633 2.5572-6.7142 2.5553-9.27517-.0056z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.05d2c0637c65daeb946f21a27c1fd29e.svg";
export { ForwardRef as ReactComponent };